var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.6083 0.44165H5.40002C2.79507 0.44165 0.68335 2.55337 0.68335 5.15832V10.8333C0.68335 13.4383 2.79507 15.55 5.40002 15.55H12.6083C15.2133 15.55 17.325 13.4383 17.325 10.8333V5.15832C17.325 2.55337 15.2133 0.44165 12.6083 0.44165Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 7.95827C7.02076 7.95827 7.98335 6.99195 7.98335 5.79993C7.98335 4.60792 7.02076 3.6416 5.83335 3.6416C4.64594 3.6416 3.68335 4.60792 3.68335 5.79993C3.68335 6.99195 4.64594 7.95827 5.83335 7.95827Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83336 12.7333C7.59146 12.7333 9.01669 11.7931 9.01669 10.6333C9.01669 9.47353 7.59146 8.53333 5.83336 8.53333C4.07525 8.53333 2.65002 9.47353 2.65002 10.6333C2.65002 11.7931 4.07525 12.7333 5.83336 12.7333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4333 10.4166H11.5C11.3342 10.4166 11.1753 10.3508 11.0581 10.2336C10.9408 10.1164 10.875 9.95739 10.875 9.79163C10.875 9.62587 10.9408 9.46689 11.0581 9.34968C11.1753 9.23247 11.3342 9.16663 11.5 9.16663H14.4083C14.5741 9.16663 14.7331 9.23247 14.8503 9.34968C14.9675 9.46689 15.0333 9.62587 15.0333 9.79163C15.0333 9.95739 14.9675 10.1164 14.8503 10.2336C14.7331 10.3508 14.5741 10.4166 14.4083 10.4166H14.4333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 7.21668H10.35C10.1843 7.21668 10.0253 7.15083 9.9081 7.03362C9.79088 6.91641 9.72504 6.75744 9.72504 6.59168C9.72504 6.42591 9.79088 6.26694 9.9081 6.14973C10.0253 6.03252 10.1843 5.96667 10.35 5.96667H14.75C14.9158 5.96667 15.0748 6.03252 15.192 6.14973C15.3092 6.26694 15.375 6.42591 15.375 6.59168C15.375 6.75744 15.3092 6.91641 15.192 7.03362C15.0748 7.15083 14.9158 7.21668 14.75 7.21668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fde4276225ec6e411952f24f85287213.svg";
export { ForwardRef as ReactComponent };